
<div class="box-plugin box-single ocr-box">
    <h3>{{title}}</h3>
    <div class="links">
    <ul>
        <li>
            <button (click)="newExtract('tetml')" [ngClass]="{'disabled-link' : contentExtract.extraction_type == 'tetml' ||  contentExtract.extraction_type == 'tetml-unordered' || !extractionBtn || apolloContent.images.status_code == 0}">Default</button>
        </li>
        <li>
            <button (click)="newExtract('hocr')" [ngClass]="{'disabled-link' : contentExtract.extraction_type == 'hocr' ||  !extractionBtn || apolloContent.images.status_code == 0}"><em>OCR</em></button>
        </li>
    </ul>
    </div>

    <core-helpers-box-loading *ngIf="status.code == 0"></core-helpers-box-loading>

    <!-- empty text -->
    <div *ngIf="status.code == EMPTY" class="extract-error">
        <span [hidden]="contentExtract.extraction_type == 'hocr'">We could not extract the content directly, you might want to try OCR.</span>
        <span [hidden]="contentExtract.extraction_type == 'tetml'">It looks like OCR could not extract any content. Please make sure the document has some text for us to extract.</span>
    </div>

    <!-- Try Again -->
    <core-helpers-box-alert-try-again *ngIf="status.code >= ERROR" text="'An error has ocurred. Please try again'" (tryAgain)="tryAgain()"></core-helpers-box-alert-try-again>
    <core-helpers-box-alert-try-again *ngIf="status.code == USER_ERROR" text="status.message" (tryAgain)="tryAgain()"></core-helpers-box-alert-try-again>
    <!--  unreliable  -->
    <div class="extract-error" *ngIf="status.code == UNRELIABLE">
        <span>
            The order of the text that we extracted is not reliable, you might encounter false positives. 
            You can try to obtain a more reliable order using OCR or Get the text anyways and review the
            false positives manually.
        </span>
        <ul>
            <li>
                <core-helpers-forms-button [text]="'Get text anyway'" (submit)="newExtract('tetml-unordered')" [ngClass]=""></core-helpers-forms-button>
            </li>
            <li>
                <core-helpers-forms-button [text]="'Try with OCR'" (submit)="newExtract('hocr')" [ngClass]=""></core-helpers-forms-button>
            </li>
        </ul>
    </div>

    <!-- Response -->

    <div class="extract-content" *ngIf="status.code == DONE" [innerHtml]="response"></div>
</div>
